import { Grid, Typography } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";

export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const ScheduleCode = styled(Typography)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
  fontWeight: 700,
  color: theme.palette.text.primary,
  fontSize: "0.9rem",
}));

export const MainTableContainer = styled(Grid)(({ theme }) => ({
  "& .isWeekend": {
    backgroundColor: lighten(theme.palette.secondary.light, 0.9),
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .isPublicHoliday": {
    backgroundColor: "pink",
    borderLeft: "1px solid white",
    borderRight: "1px solid white",
  },

  "& .hasAnomalies": {
    backgroundColor: lighten(theme.palette.error.light, 0.9),
    // borderLeft: "1px solid white",
    // borderRight: "1px solid white",
  },
}));

export const AbsencesContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "100%",

  "& > .MuiButton-root": {
    padding: "0px",
  },
});

export const ClientIconContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "5px",
});
